import { Icon } from "@mdi/react";
import React from "react";

import { mdiContentCopy } from "@mdi/js";
import { Button } from "antd";
import styled from "styled-components";
import { arrayOrEmpty } from "utils";

import { EntityKind } from "models/entityKind";

import { useAutomationBroker } from "components/automation/contexts/AutomationBrokerContext";
import { AutomationCommand } from "components/automation/types/automation";
import {
  LoadSavedFilterPayload,
  SettingsProps
} from "components/automation/types/payloads";
import { FilterInfoResult } from "components/automation/types/results";
import { Topics } from "components/automation/types/topics";
import { useProjectListQuery } from "components/project/projects/queries";

export const LoadSavedFilterSettings: React.FC<SettingsProps<LoadSavedFilterPayload>> = ({
  value,
  onChange
}) => {
  const projectListQuery = useProjectListQuery();
  const broker = useAutomationBroker();
  const loadCurrentProjectAndFilter = async () => {
    const result = await broker.executeCommands([
      {
        id: "get project and filter",
        topic: Topics.GetProjectIdAndSavedFilterInfo,
        delay: 200
      } as AutomationCommand
    ]);
    const item = result.find(
      (r) => (r as FilterInfoResult)?.entityKind === EntityKind.Well
    ) as FilterInfoResult;
    if (!item || !item.filterId || !item.projectId) {
      return;
    }

    const project = arrayOrEmpty(projectListQuery.data).find(
      (proj) => proj.projectId === item.projectId
    );

    onChange({
      projectId: item.projectId,
      filterName: item.filterName,
      projectName: project.projectName
    } as LoadSavedFilterPayload);
  };

  return (
    <StyledContainer>
      <StyledCopyButton
        size="large"
        onClick={loadCurrentProjectAndFilter}
        icon={<Icon path={mdiContentCopy} size={1.2} />}>
        Copy Current Project and Filter
      </StyledCopyButton>
      <StyledLabelValue>
        <span className="label">Filter Name:</span>
        <span className="value">{value?.filterName ?? ""}</span>
      </StyledLabelValue>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
  padding: 8px 0;
`;

const StyledLabelValue = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fafbfc;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 15px;
  .label {
    font-weight: 600;
    color: #444;
    min-width: 110px;
  }
  .value {
    color: #222;
    word-break: break-all;
  }
`;

const StyledCopyButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 12px;
  width: fit-content;
  font-size: 1.15rem;
  font-weight: 600;
  padding: 12px 28px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);
`;
